import { isAfter, isBefore, isWithinInterval } from 'date-fns';

export function isInDateRange(params: { now: Date; fromDate?: Date; toDate?: Date }): boolean {
  const { now, fromDate, toDate } = params;

  try {
    if (fromDate && toDate && isWithinInterval(now, { start: fromDate, end: toDate })) {
      return true;
    }

    if (fromDate && !toDate && isAfter(now, fromDate)) {
      return true;
    }

    if (toDate && !fromDate && isBefore(now, toDate)) {
      return true;
    }

    return false;
  } catch (e) {
    return false;
  }
}
